export const EmbedPluginID = 'embed';
